import { getAssetUrl } from '../../Common/Utils/assetUrl';
export const mapB2CTenantToLanding = (tenantData) => {
  const theme  = tenantData?.theme  || {};
  const topBar = tenantData?.topBar || {};
  const header = tenantData?.header || {};
  const footer = tenantData?.footer || {};
  const hero   = tenantData?.hero   || {};

  return {
      isPreview: tenantData?.isPreview ?? false,
    companyId:   tenantData?.companyId,
    branchId:    tenantData?.branchId,
    userId:      tenantData?.userId,
    logoUrl: getAssetUrl(tenantData?.branding?.logoUrl),
    companyName: tenantData?.branding?.companyName || 'Travel Agency',
    brandName:   tenantData?.branding?.brandName   || 'Travel Agency',
    email:    tenantData?.branding?.email    || 'info@travelagency.com',
    phones:   tenantData?.branding?.phones   || '9000000000',
    whatsapp: tenantData?.branding?.whatsapp || '9000000000',
    socials:  tenantData?.branding?.socials  || {},
     companyData:     tenantData?.companyData || {},
     seo: tenantData?.seo || {},
    themeColor1: theme.themeColor1 || theme.themecolor1,
    themeColor2: theme.themeColor2 || theme.themecolor2,
    themeColor3: theme.themeColor3 || theme.themecolor3,
    themeColor4: theme.themeColor4 || theme.themecolor4,
    themeColor5: theme.themeColor5 || theme.themecolor5,
    topBarBg:   topBar.bgColor   || '#4f46e5',
    topBarText: topBar.textColor || '#ffffff',
    headerBg:   header.bgColor   || '#ffffff',
    headerText: header.textColor || '#1e1b4b',
    footerBg:   footer.bgColor   || '#1e1b4b',
    footerText: footer.textColor || '#ffffff',
    headingFont: tenantData?.branding?.headingFont || 'Plus Jakarta Sans',
    bodyFont:    tenantData?.branding?.bodyFont    || 'Inter',
    heroData: {
      flights:     { title: hero.flights?.title     || 'Search Flights',   subTitle: hero.flights?.subTitle     || 'Best fares guaranteed.' },
      hotels:      { title: hero.hotels?.title      || 'Search Hotels',    subTitle: hero.hotels?.subTitle      || 'Handpicked stays for you.' },
      holidays:    { title: hero.holidays?.title    || 'Explore Holidays', subTitle: hero.holidays?.subTitle    || 'Curated packages.' },
      sightseeing: { title: hero.sightseeing?.title || 'Find Activities',  subTitle: hero.sightseeing?.subTitle || 'Discover experiences.' },
    },
  };
};

export const getB2CColors_T40 = (landingData) => {
  const c1 = landingData.themeColor1 || '#4f46e5'; // electric indigo
  return {
    theme1:     c1,
    theme2:     landingData.footerBg    || '#1e1b4b',   // deep navy indigo footer
    theme3:     landingData.headerBg    || '#ffffff',
    theme4:     landingData.themeColor4 || '#f5f3ff',   // light lavender bg
    theme5:     landingData.themeColor5 || '#1e1b4b',
    accent:     landingData.themeColor2 || '#f59e0b',   // amber
    headerText: landingData.headerText  || '#1e1b4b',
    footerText: landingData.footerText  || '#ffffff',
    topBarBg:   landingData.topBarBg    || '#4f46e5',
    topBarText: landingData.topBarText  || '#ffffff',
  };
};

// Per-module vibrant color palette — used by ModuleTabsBar & search pages
export const MODULE_COLORS = {
  flights:     { color: '#4f46e5', light: '#eef2ff', shadow: 'rgba(79,70,229,0.25)'   },
  hotels:      { color: '#ec4899', light: '#fdf2f8', shadow: 'rgba(236,72,153,0.25)'  },
  buses:       { color: '#f59e0b', light: '#fffbeb', shadow: 'rgba(245,158,11,0.25)'  },
  holidays:    { color: '#10b981', light: '#d1fae5', shadow: 'rgba(16,185,129,0.25)'  },
  sightseeing: { color: '#06b6d4', light: '#ecfeff', shadow: 'rgba(6,182,212,0.25)'   },
  visa:        { color: '#ef4444', light: '#fef2f2', shadow: 'rgba(239,68,68,0.25)'   },
  umrah:       { color: '#8b5cf6', light: '#f5f3ff', shadow: 'rgba(139,92,246,0.25)'  },
  hajj:        { color: '#f97316', light: '#fff7ed', shadow: 'rgba(249,115,22,0.25)'  },
};
